import { Dismiss20Regular } from '@fluentui/react-icons';
import { SkillsTopContainer } from '../../SkillsAddPopup/styles/SkillsAddPopup.styled';

interface SkillTopContainerProps {
  onClose: () => void;
  title: string;
}

export const SkillTopContainer = ({
  onClose,
  title,
}: SkillTopContainerProps) => {
  return (
    <SkillsTopContainer>
      <h1>{title}</h1>
      <Dismiss20Regular onClick={onClose} />
    </SkillsTopContainer>
  );
};
